import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { NeonButton } from "@/components/Buttons";
import { scrollToId } from "@/lib/ui";

const SEQUENCE = [
  { text: "LEARN THE GAME PLAN.", tone: "text-mist" },
  { text: "FOLLOW THE PROCESS.", tone: "text-mist" },
  { text: "MEASURE THE EXECUTION.", tone: "text-mist" },
  { text: "IMPROVE THE EXECUTOR.", tone: "text-neon" },
];

export default function FinalCtaV2() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden py-28 text-center lg:py-40"
    >
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[820px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-neon/[0.05] blur-[160px]" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6">
        <Reveal>
          <div className="font-mono text-[11px] uppercase leading-relaxed tracking-[0.3em] text-dim">
            You don't need to keep chasing strategies.
          </div>
          <div className="mt-2 font-mono text-[11px] uppercase leading-relaxed tracking-[0.3em] text-mist">
            You need a Game Plan you can execute.
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-display text-6xl font-extrabold uppercase leading-[1.0] tracking-tight text-white sm:text-8xl">
            Become
            <br />
            the <span className="glow-text-neon text-neon">Executor.</span>
          </h2>
        </Reveal>

        <div className="mt-12 space-y-2.5">
          {SEQUENCE.map((l, i) => (
            <Reveal key={l.text} delay={0.2 + 0.09 * i}>
              <div className={`font-mono text-xs uppercase tracking-[0.3em] sm:text-sm ${l.tone}`}>
                {l.text}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.55}>
          <div className="glow-text-neon mt-12 font-display text-2xl font-extrabold uppercase tracking-tight text-neon sm:text-4xl">
            Execution
            <br />
            over everything.™
          </div>
        </Reveal>

        <Reveal delay={0.65}>
          <NeonButton
            testid="final-cta-button"
            onClick={() => scrollToId("pricing")}
            className="mt-12 px-10 py-4 text-base"
          >
            Join Execution Traders
            <ArrowRight size={18} />
          </NeonButton>
        </Reveal>

        <Reveal delay={0.75}>
          <div className="mt-16">
            <div className="font-display text-2xl font-extrabold tracking-tight text-white">
              P.E.E. OS™
            </div>
            <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
              Position • Event • Entry
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
